module.exports = __webpack_public_path__ + "img/Pfade_Fynn_12.9afce28c.png";